import { GanttColumnForm } from '@gantt/components/GanttCreateOrEdit'

export const getColumnsFormatted = (columns: GanttColumnForm[]) => {
  if (!columns || !columns.length) {
    return []
  }

  return columns.map(item => {
    const transformedItem = { ...item }
    if (transformedItem.bindType && typeof transformedItem.bindType === 'object') {
      transformedItem.bindType =
        transformedItem.bindType.id || transformedItem.bindType.label || null
    }

    return transformedItem
  })
}
